<template>
  <div class=" uk-padding uk-padding-remove-vertical uk-margin-remove-top uk-background-muted" uk-scrollspy="target: > div; cls:uk-animation-fade; delay: 100">
    <br><br>
    <h1  class="uk-heading-line uk-text-center specHeading" ><span>Upcoming Events</span> </h1>
      <p class="uk-margin-remove-top uk-link-text uk-align-center uk-text-center uk-text-small">Click the image to enlarge</p>
    <div class="uk-container uk-container-small">
      <div uk-slider="autoplay: true; autoplay-interval: 2500; pause-on-hover: true">

        <div class="uk-position-relative">

          <div class="uk-slider-container uk-light">
            <ul class="uk-slider-items uk-child-width-1-1 uk-child-width-1-1@s uk-child-width-1-2@m uk-child-width-1-3@m">
              <li v-for="item in loadEvents" class="uk-padding-small">
                <div class="uk-card ">
                  <div class="uk-card-media-top">
                    <a class="uk-button uk-button-default" href="#upcomingEventsModal" uk-toggle>
                      <img :src="'http://cmsapi.ncu.edu.jm/' + item.upcomingEventImage" :id="item._id" v-on:click="showInModal" style="border-radius: 10px"  alt="">
                    </a>
                  </div>
                </div>
              </li>

            </ul>
          </div>

          <div class="uk-hidden@s uk-light">
            <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
            <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
          </div>

          <div class="uk-visible@s">
            <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
            <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
          </div>

        </div>



      </div>
      <div id="upcomingEventsModal" class="uk-flex-top" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">

          <button class="uk-modal-close-default" type="button" uk-close></button>
          <img :src="'http://cmsapi.ncu.edu.jm/' + loadEvent.upcomingEventImage" alt="">
        </div>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
  export default {
    name: "upcomingevents",
    data(){
      return{
        root: this.$store.state.newsevents.strapiApi,
        //rootTest: this.$store.state.rootTest1,
        //modalInfo: this.$store.state.upcomingEvent
      }
    },
    methods: {
      showInModal: function(event){

        this.$store.dispatch('newsevents/getUpcomingEvent', {eventID: event.target.id})
      }
    },
    computed: {
      loadEvents: function () {
        console.log(this.$store.state.newsevents.UpcomingEventsList)
        return this.$store.state.newsevents.UpcomingEventsList
      },
      loadEvent: function () {
        //console.log(this.$store.state.newsevents.upcomingEvent)
        console.log(this.$store.state.newsevents.UpcomingEvent)
        return this.$store.state.newsevents.UpcomingEvent
      },

    },
    mounted(){
      //window.scrollTo(0, 0);
      this.$store.dispatch('newsevents/getUpcomingEvents')

    },
  }
</script>

<style scoped>
  #headers{
    font-family: "Alegreya SC";

  }
  @media screen and (max-width:600px){


    h1{
      font-size: 1.4em !important;
    }

  }
</style>
